<template>
  <section class="GalerieSection s2" id="fotos" v-scroll-reveal>
    <div class="home-galerie-wrapper">
      <h1>fotos</h1>
      <article class="home-galerie-text"></article>
      <div class="home-galerie-img-wrapper">
        <div class="prev-wrapper">
          <router-link to="fotos/portrait" class="prev people">
            <h2>Portrait</h2>
          </router-link>
        </div>
        <div class="prev-wrapper">
          <router-link to="fotos/corporate" class="prev corporate">
            <h2>Corporate</h2>
          </router-link>
        </div>
        <div class="prev-wrapper">
          <router-link to="fotos/events" class="prev events">
            <h2>Hochzeit / Events</h2>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "GalerieSection",
};
</script>

<style lang="scss" scoped>
#fotos {
  .home-galerie-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .home-galerie-img-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: none;
      grid-gap: 5vw;
      justify-content: center;
      align-items: center;
      .prev-wrapper {
        height: 25vw;
        .prev {
          height: 25vw;
          width: 25vw;
          display: flex;
          background-repeat: no-repeat;
          justify-content: center;
          align-items: center;
          text-decoration: none;
          justify-self: center;
          border-radius: 10px;
          transition: all 0.3s;
          &:hover {
            transform: scale(1.02);
            -ms-transform: scale(1.02);
            -webkit-transform: scale(1.02);
          }
          h2 {
            text-align: center;
            margin-top: 1vw;
            padding: 1vw 3vw 1vw 3vw;
            color: #f5f4f3;
            text-transform: uppercase;
            font-weight: 700;
            letter-spacing: 0.1rem;
          }
        }
        .people {
          background-image: url(~@/assets/img/gallery/portrait/leona_10_ocular.jpg);
          background-size: cover;
          background-position: center;
        }
        .events {
          background-image: url(~@/assets/img/gallery/events/hochzeit_kuss_ocular.jpg);
          background-size: cover;
          background-position-y: center;
        }
        .corporate {
          background-image: url(~@/assets/img/gallery/corporate/kita_3_ocular.jpg);
          background-size: cover;
          background-position-y: center;
        }
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  #fotos {
    .home-galerie-wrapper {
      .home-galerie-img-wrapper {
        grid-template-columns: 1fr;
        grid-gap: 10vw;
        .prev-wrapper {
          height: 80vw;
          .prev {
            width: 80vw;
            height: 80vw;
          }
        }
      }
    }
  }
}
</style>
